import { StatisticsType } from '@store/modules/ui/sportOffer/enums';
import devEnvironments from '@countryConfig/devEnvironment';
import { get as _get } from '@lodash';

const loadRequired = (name: string): string => {
    const v = process.env[name];
    if (!v) {
        throw new Error(`Missing required '${name}' environment variable`);
    }
    return v;
};

const env = loadRequired('NODE_ENV');
const appEnv = loadRequired('APP_ENV');
const platform = loadRequired('PLATFORM');
const ldClientId = loadRequired('LD_CLIENT_ID');
console.log('SSBT::App Environment', appEnv, platform);

const isTest = env === 'test';

function getLocale() {
    if (isTest || window.location.host.includes('localhost')) {
        return 'en-GB';
    }

    const countries = {
        romania: 'ro-RO',
        poland: 'pl-PL',
        croatia: 'hr-HR',
    };

    // @ts-ignore
    return countries[process.env.COUNTRY];
}

function getNumberLocale() {
    return 'ro-RO';
}

function getCountry() {
    return process.env.COUNTRY || 'romania';
}

const devEnvironment = _get(devEnvironments, `${platform}.${appEnv}`);
console.log('SSBT::Dev Environment proper >>', devEnvironment);

let backendServer;
let offerServer;
let frontendServer;
let ticketsCache;
let configHost = devEnvironment.configHost;
let newsHost;
let googleMapsApiKey;
let saAPIKey;
let countryKey = devEnvironment.countryKey;
let envCluster;
const paymentHostApi = devEnvironment.paymentHost;
const paymentHostSocket = devEnvironment.paymentHostSocket;
const socketPath = devEnvironment.socketPath;

let appVersion = process.env.DOCKER_IMAGE_TAG;

switch (!isTest && window.location.host) {
    case 'beta.superbet.ro':
    case 'www.beta.superbet.ro':
        envCluster = '';
        appVersion = '';
        (window as any).superbetVersion = process.env.DOCKER_IMAGE_TAG;
        backendServer = 'https://ct-prod-bcknd.superbet.ro';
        offerServer = 'https://offer.superbet.ro';
        frontendServer = 'https://www.superbet.ro';
        ticketsCache = 'https://tickets-cache.betting.superbet.ro';
        configHost = 'https://www.superbet.ro';
        newsHost = 'https://ftv4.sa-api.info';
        googleMapsApiKey = 'AIzaSyDgH9Vz3-J75DN3IJjHWUTSO_3DCvCw7l4';
        break;
    case 'www.silent.superbet.ro':
        envCluster = 'prod';
        backendServer = 'https://ct-prod-bcknd.superbet.ro';
        offerServer = 'https://offer.superbet.ro';
        frontendServer = 'https://www.superbet.ro';
        ticketsCache = 'https://tickets-cache.betting.superbet.ro';
        configHost = 'https://www.superbet.ro';
        newsHost = 'https://ftv4.sa-api.info';
        googleMapsApiKey = 'AIzaSyDgH9Vz3-J75DN3IJjHWUTSO_3DCvCw7l4';
        break;
    case 'www.stage.superbet.ro':
        envCluster = 'stage';
        backendServer = 'https://ct-st-bcknd.superbet.ro';
        offerServer = 'https://dev-offer.superbet.ro';
        frontendServer = 'https://ct-rc-www.superbet.ro/';
        ticketsCache = 'https://tickets-cache.betting.stage.superbet.ro';
        configHost = 'https://ct-rc-www.superbet.ro/';
        newsHost = 'https://ftv4.sa-api.info';
        googleMapsApiKey = 'AIzaSyDgH9Vz3-J75DN3IJjHWUTSO_3DCvCw7l4';
        break;
    case 'pl':
        frontendServer = 'https://ct-st-www.superbet.pl';
        saAPIKey = 'S6eVzsbZEoV0lnPL';
        countryKey = 'pl';
    default:
        break;
}

export default {
    printedTicket: {
        footerCenterLines: devEnvironment.footerCenterLines,
    },
    services: {
        frontendServer,
        googleMaps: {
            apiKey: googleMapsApiKey,
        },
        googleAnalytics: {
            id: 'UA-128164307-2'
        },
        allowancesUrl: devEnvironment.allowancesUrl,
        virtualTournamentsEndpoint: devEnvironment.virtualTournamentsEndpoint,
        country: {
            host: backendServer,
            frontEndHost: frontendServer,
        },
        smdc: {
            // list of shops which are more accurate than comtrade's.
            // we need to filter out all shops from cometrade which doesn't ecist in smdc
            host: 'https://abs.smdc.ro',
            authorizationKey: 'Qu6u>7F!JTq}<sXaQj20v&iY@fW=;E',
        },
        countryConfig: {
            host: configHost
        },
        offer: {
            host: offerServer,
            socket: offerServer,
            // host: 'https://dev-offer.superbet.ro',
            // socket: 'https://dev-offer.superbet.ro/'
        },
        casino: {
            host: frontendServer,
            bannerReloadPeriod: 5 * 1000,
            bannerBackground: `${frontendServer}/documents/jocuri-cu-jackpot.png`,
        },
        auth: {
            host: backendServer
        },
        user: {
            host: backendServer
        },
        bonus: {
            host: backendServer
        },
        videoStreams: {
            host: frontendServer,
        },
        lotto: {
            host: offerServer
        },
        tickets: {
            retrieval: {
                host: ticketsCache,
            },
            payment: {
                socketPath,
                host: paymentHostApi,
                hostSocket: paymentHostSocket,
            },
            timeout: 1000 * 60 * 5
        },
        news: {
            host: newsHost,
            apiKey: saAPIKey,
            country: countryKey,
            fetchNewsPeriod: 1 * 60 * 60 * 1000, // 1 hour
        },
        broadcast: {
            host: 'https://api-staging.score-alarm.eu',
            apiKey: saAPIKey,
            country: countryKey,
        },
        virtual: {
            host: 'https://seven-web-superbetwebcomtrade.nsoft.ba'
        },
        specialTournament: {
            host: 'https://ftv4.sa-api.info',
            apiKey: saAPIKey,
            country: countryKey,
        },
        sentry: {
            dsn: 'https://772c0e783bec477b99d2cec226b45049@o139620.ingest.sentry.io/5853240',
        },
    },

    // to distinguish legacy users who haven't choose GDPR consent yet
    launchDate: new Date(2018, 5, 25),

    locale: getLocale(),

    language: getLocale().split('-')[0],

    numberLocale: getNumberLocale(),

    country: getCountry(),

    format: {
        date: 'YYYY-MM-DD HH:mm:ss'
    },

    app: {
        // launchDarkly client id
        ldClientId,
        scrollDuration: 400,
        config: {
            configFetchTimeout: 5 * 1000,
        },
        design: {
            breakingPointWidth: 1440,
        },
        banners: {
            minPromotionBanners: 2,
        },
        country: {
            checkIsMaintenanceModePeriod: 5 * 60 * 1000,
            bannerChangePeriod: 10 * 1000,
            incomingBannersCheckPeriod: 30 * 60 * 1000,
            defaultMaintenanceUrl: 'https://www.superbet.today/03/',
        },
        auth: {
            passwordMinLength: 6,
        },
        staticPages: {
            documentsHost: frontendServer,
            imagesHost: frontendServer,
        },
        user: {
            lowBalance: 2,
            deposit: {
                onlineMin: 20,
                onlineMax: 20000,
                iframeWidth: 650,
                iframeHeight: 610,
                quickAmounts: [
                    50,
                    150,
                    200,
                ],
                bankTransferIban: 'RO38 ROIN 9109 0019 1412 RO01',
                bankTransferBank: 'IDEA BANK',
                bankTransferCurrency: 'RON',
                bankTransferAccountName: 'Superbet Interactive (Romania) Limited',
                bankTransferSwift: 'ROINROBU',
                bankTransferCity: 'Bucharest',
            },
            withdrawal: {
                tax: '0|66750|0|0.01|66750|445000|667.5|0.16|445000|0|61187.5|0.25',
                savedLastNShops: 5,
                bankTransferMin: 20,
                bankTransferMax: 50000,
                onlineMin: 20,
                onlineMax: 20000,
                shopMin: 10,
                shopMax: 40000,
                instantMin: 10,
                instantMax: 400,
                iframeWidth: 650,
                iframeHeight: 610,
                pscTransferTax: 0.01,
                minTaxableAmount: 50, // taxable >= 50
            },
            history: {
                pageSize: 5,
            },
            idCardVerification: {
                fileSize: 5 * 1024 * 1024, // check also fileSizeHumanReadable
                fileSizeHumanReadable: '5MB',
                allowedFormats: [
                    'image/jpeg',
                    'image/png',
                ],
                pendingHours: 72,
                uploadRequestTimeout: 1000 * 60 * 5, // 5 minutes
            },
            sessionDurationNotificationPeriod: 2 * 60 * 1000, // 2 minutes
            balanceRefreshPeriod: 60 * 1000,
        },
        betSlip: {
            bonus: {
                minimumItems: 6,
                percentageUnit: 5,
            },
            minStakeForSimple: 2,
            minStakeForSystem: 2,
            maxSystemSelections: 16,
            decimalPlaces: 8,
            maxSelections: 16,
            stakes: [
                10,
                100,
                500
            ],
            undoClearDuration: 1000 * 5,
        },

        lottoBetSlip: {
            onlineTax: 5,
            offlineTax: 5,
            maxSystems: 16,
            decimalPlaces: 8,
            maxSelections: 16,
            stakes: [
                10,
                100,
                500
            ],
            undoClearDuration: 1000 * 5,
        },

        results: {
            maxDaysToFetch: 31,

            virtual: {
                baseUrl: 'https://seven-web-superbet.7platform.com/#',
                excludedGames: ['sb-vf', 'sr-vto', 'sb-vt']
            },

            retail: {
                baseUrl: 'https://seven-web-superbet.nsoft.ba'
            },

            special: {
                baseUrl: offerServer
            },

            clab: {
                baseUrl: 'https://offer.superbet.ro/'
            }
        },

        lotto: {
            minStake: 1,
            maxLottoNumbersDrawn: 8,
            dateSubtract: 0,
            dateAdd: 1,
            endDate: { hour: 10, minute: 0, second: 0 },
            startDate: { hour: 0, minute: 0, second: 0 },
            ballsPerLine: 8,
            maxRandomNumbers: 5,
            countdownInterval: 5 * 60 * 1000,
            updateTimerInterval: 1000,
            featuredGames: [
                // Grecia keno
                {
                    id: 83,
                    country: 'ITALIA',
                    name: 'Italia Keno 10e Loto 2090',
                    numbersDrawn: 20,
                    totalNumbers: 90,
                },
                // Italia keno
                {
                    id: 6,
                    country: 'GRECIA',
                    name: 'Grecia Kino 2080',
                    numbersDrawn: 20,
                    totalNumbers: 80,
                },
                // Win for life
                {
                    id: 9,
                    country: 'ITALIA',
                    name: 'Win For Life 1020',
                    numbersDrawn: 10,
                    totalNumbers: 20,
                },
            ],
            favouritesWaitingTime: 1000 // 1 second,
        },

        utils: {
            bookieShopStartTime: 10,
        },

        specialOffer: {
            fetchInterval: 1 * 60 * 60 * 1000, // 1 hour
        },

        sportOffer: {
            gridDateFutureThreshold: 6,
            oddDynamicsPreserveTime: 3, // in seconds
            eventGridSort: [
                'sportOrder',
                'specialTournamentOrder',
                'categoryName',
                'tournamentOrder',
                'tournamentName2',
                'date',
                'code',
                'id'
            ],
            initiallyExpandedMarketsNumber: 3, // -1 is off
            popularMarketsNumber: 4,
            statistics: {
                key: saAPIKey,
                types: [
                    StatisticsType.matchDetails,
                    StatisticsType.statistics,
                    StatisticsType.h2h,
                    StatisticsType.lineups,
                    StatisticsType.tables,
                    StatisticsType.cupRoster,
                ]
            },
            filter: {
                alwaysExpandedTournamentsNumber: 5,
                oddTolerance: [
                    {
                        from: 1,
                        to: 2,
                        values: [
                            0.1,
                            0.25,
                            0.5
                        ]
                    },
                    {
                        from: 2,
                        to: 5,
                        values: [
                            1,
                            2,
                            3
                        ]
                    },
                    {
                        from: 5,
                        to: undefined,
                        values: [
                            5,
                            10,
                            15
                        ]
                    }
                ]
            },
            featuredEvents: { /*
                362: {
                    id: 362, // tournament id
                    categoryId: 159,
                    sportId: 5,
                    order: 1,
                    img: {
                        url: '/static/img/specials/basketball-worldcup.svg',
                        height: '64px'
                    }
                },
                344: {
                    id: 344, // tournament id
                    categoryId: 45,
                    sportId: 4,
                    order: 2,
                    img: {
                        url: '/static/img/specials/flag-us-open.svg',
                        height: '64px'
                    }
                }
            */},
        },

        format: {
            date: ['dd', 'mm', 'yyyy'],
            time: ['HH', 'MM'],
            apiDateFormat: 'YYYY-MM-DD HH:mm:ss', // api date format for tickets
        },

        ticketsPage: {
            defaultPageSize: 10,
            stackSize: 10,
        },

        search: {
            numberOfResults: 10,
            numberOfSuggestions: 5,
        },

        games: {
            mobileWidth: 768,
        },

        googleMaps: {
            // Bucharest location by default
            defaultLocation: {
                latitude: 44.439663,
                longitude: 26.096306,
            },
            // constant from google maps
            defaultZoom: 16,
            clusterMaxZoom: 13,
        },

    },

    environment: {
        appEnv,
        platform,
        isQa: appEnv === 'qa',
        isSilent: appEnv === 'silent',
        isNSoft: platform === 'nsoft',
        isInHouse: platform === 'in-house',
        name: env,
        cluster: envCluster,
        isProduction: env === 'production',
        isDevelopment: env === 'development',
        isTest: env === 'test',
        isAxCluster: envCluster === 'ax',
        version: appVersion,
    },

    cache: {
        // set to 31 to cache all results, ask somebody what should be threshold?
        numberOfDaysToCache: 3,
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/config/common.ts